import { Route, Routes } from 'react-router-dom';

import { Home } from './Containers/Home/Home';
import { Offline } from './Containers/Welcome/Offline';
import { ActivateInLumia } from './Containers/Welcome/ActivateInLumia';
import { Welcome } from './Containers/Welcome/Welcome';

export function Router() {
	return (
		<Routes>
			<Route path="/activate" element={<ActivateInLumia />} />
			<Route path="/home" element={<Home />} />
			<Route path="/offline" element={<Offline />} />
			<Route path="*" element={<Welcome />} />
		</Routes>
	);
}
